<div class="tsd_container">
  <form [formGroup]="clientForm">
    <mat-card>
      <mat-card-content>
        <h4 class="__card_head">Client</h4>
        <mat-form-field>
          <mat-label>Client Code</mat-label>
          <input matInput placeholder="Client Code" formControlName="code" autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Client Name</mat-label>
          <input matInput placeholder="Client Name" formControlName="name" autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Email id</mat-label>
          <input matInput placeholder="Email id" formControlName="emailId" autocomplete="off">
        </mat-form-field>
        <mat-form-field>
          <mat-label>Contact No</mat-label>
          <input matInput placeholder="Contact No" formControlName="mobileNo" autocomplete="off">
        </mat-form-field>
      </mat-card-content>
    </mat-card>

    <mat-card>
      <mat-card-content>
        <h4 class="__card_head">Client GSA Details</h4>
        <!-- <pre>{{gsaDetails|json}}</pre> -->
        <table class="document_list" mat-table [dataSource]="gsaDataSource" formArrayName="gsaDetails">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef> Name </th>
            <td mat-cell *matCellDef="let row; let index = index"  [formGroupName]="index">
              <mat-form-field class="filter search_box" >
                <input type="text" placeholder="Name" matInput
                  formControlName="name" autocomplete="off">
                </mat-form-field>
              </td>
            </ng-container>
            <ng-container matColumnDef="emailId">
              <th mat-header-cell *matHeaderCellDef> Email </th>
              <td mat-cell *matCellDef="let row; let index = index"  [formGroupName]="index">
                <mat-form-field class="filter search_box">
                  <input type="text" placeholder="Email" matInput
                    formControlName="emailId" autocomplete="off">
                  </mat-form-field>
                </td>
              </ng-container>
              <ng-container matColumnDef="contactNumber">
                <th mat-header-cell *matHeaderCellDef> Contact No </th>
                <td mat-cell *matCellDef="let row; let index = index"  [formGroupName]="index">
                  <mat-form-field class="filter search_box">
                    <input type="text" placeholder="Contact No" matInput
                      formControlName="contactNumber" autocomplete="off">
                    </mat-form-field>
                  </td>
                </ng-container>

                <ng-container matColumnDef="userRoles">
                  <th mat-header-cell *matHeaderCellDef> Role </th>
                  <td mat-cell *matCellDef="let element; let gsaColIndex = index;let last = last"  [formGroupName]="gsaColIndex">
                    <mat-form-field class="example-chip-list">
                      <mat-chip-grid #chipList>
                        @for (_item of element.role; track _item; let roleIndex = $index) {
                          <mat-chip-row [removable]="true"
                            (removed)="removeRole(gsaColIndex,roleIndex)">
                            {{_item.roleName}}
                            <mat-icon matChipRemove>cancel</mat-icon>
                          </mat-chip-row>
                        }
                        <input placeholder="Role" #roleInput formControlName="userRoles" [matAutocomplete]="auto"
                          [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                        </mat-chip-grid>
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addRole($event,gsaColIndex)">
                          @for (_item of filteredRole | async; track _item) {
                            <mat-option [value]="_item.roleName">
                              {{_item.roleName}}
                            </mat-option>
                          }
                        </mat-autocomplete>
                      </mat-form-field>

                      @if (last===false) {
                        <button class="__delete_btn" (click)="removeGsa(gsaColIndex)" mat-icon-button
                          color="primary" (keyup.Tab)="newGsa($event,gsaColIndex)">
                          <mat-icon class="__delete_icon">delete</mat-icon>
                        </button>
                      }
                    </td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="gsaColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: gsaColumns;"></tr>
                </table>
              </mat-card-content>
            </mat-card>


            <!-- <mat-card>
            <mat-card-content>
              <h4 class="__card_head">Client GSA Details</h4>
              <table class="document_list" mat-table [dataSource]="gsaDataSource" formArrayName="gsaDetails">

                <ng-container matColumnDef="{{col.id}}" *ngFor="let col of gsaCol;">
                  <th mat-header-cell *matHeaderCellDef>
                    <span *ngIf="col.id !== '$$edit'">
                      {{col.name}}
                    </span>
                  </th>

                  <td mat-cell *matCellDef="let element;let gsaColIndex = index;let last = last" [formGroupName]="gsaColIndex">
                    <div *ngIf="((!element.isEdit || gsaIndex!=gsaColIndex+1) && last===false)"
                      (dblclick)="element.isEdit=!editGsa(gsaColIndex+1)">
                      <div class="btn-edit" *ngIf="col.id === '$$edit'; spanHeader">
                        <button class="__delete_btn" *ngIf="last===false" (click)="removeGsa(gsaColIndex)" mat-icon-button
                          color="primary">
                          <mat-icon class="__delete_icon">delete</mat-icon>
                        </button>
                      </div>
                      <span #spanHeader *ngIf="col.id !== 'role'">
                        {{element[col.id]}}
                      </span>
                      <span *ngIf="col.id === 'role'">
                        <mat-form-field class="example-chip-list">
                          <mat-chip-grid #chipList>
                            <mat-chip-row *ngFor="let _item of element.role;let roleIndex = index;" [removable]="true"
                              (removed)="removeRole(gsaColIndex,roleIndex)">
                              {{_item.roleName}}
                              <mat-icon matChipRemove>cancel</mat-icon>
                            </mat-chip-row>
                            <input placeholder="Role" #roleInput formControlName="userRoles" [matAutocomplete]="auto"
                              [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                            </mat-chip-grid>
                            <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addRole($event,gsaColIndex)">
                              <mat-option *ngFor="let _item of filteredRole | async" [value]="_item.roleName">
                                {{_item.roleName}}
                              </mat-option>
                            </mat-autocomplete>
                          </mat-form-field>
                        </span>
                      </div>

                      <div *ngIf="element.isEdit && gsaIndex===gsaColIndex+1" (clickOutside)="updateGsa(gsaColIndex)"
                        [excludeBeforeClick]=true [exclude]="'.__editable'" class="__editable">
                        <div class="btn-edit" *ngIf="col.id === '$$edit'; else dataField">
                          <button class="__delete_btn" (click)="removeGsa(gsaColIndex)" mat-icon-button color="primary"
                            focusable="false">
                            <mat-icon class="__delete_icon">delete</mat-icon>
                          </button>
                        </div>
                        <ng-template #dataField>
                          <mat-form-field *ngIf="col.id !== 'role'">
                            <input type="text" [formControl]="getControlGsa(gsaColIndex, col.id)" matInput
                              value="{{element[col]}}">
                              <mat-error *ngIf="getControlGsa(gsaColIndex, col.id).hasError('required')">
                                Field is <strong>required</strong>
                              </mat-error>
                            </mat-form-field>

                            <div *ngIf="col.id === 'role'">
                              <mat-form-field class="example-chip-list">
                                <mat-chip-grid #chipList>
                                  <mat-chip-row *ngFor="let _item of element.role;let roleIndex = index;" [removable]="true"
                                    (removed)="removeRole(gsaColIndex,roleIndex)">
                                    {{_item.roleName}}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                  </mat-chip-row>
                                  <input placeholder="Role" #roleInput formControlName="userRoles" [matAutocomplete]="auto"
                                    [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                                  </mat-chip-grid>
                                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addRole($event,gsaColIndex)">
                                    <mat-option *ngFor="let _item of filteredRole | async" [value]="_item.roleName">
                                      {{_item.roleName}}
                                    </mat-option>
                                  </mat-autocomplete>
                                </mat-form-field>
                              </div>
                            </ng-template>
                          </div>

                          <div *ngIf="last===true">
                            <mat-form-field *ngIf="col.id !== 'role' && col.id !== '$$edit'">
                              <input type="text" [formControl]="getControlGsa(gsaColIndex, col.id)" matInput>
                              <mat-error *ngIf="getControlGsa(gsaColIndex, col.id).hasError('required')">
                                Field is <strong>required</strong>
                              </mat-error>
                            </mat-form-field>
                            <div *ngIf="col.id === 'role'">
                              <mat-form-field class="example-chip-list">
                                <mat-chip-grid #chipList>
                                  <mat-chip-row *ngFor="let _item of element.role" [removable]="true"
                                    (removed)="removeRole(gsaColIndex,_item)">
                                    {{_item.roleName}}
                                    <mat-icon matChipRemove>cancel</mat-icon>
                                  </mat-chip-row>
                                  <input placeholder="Role" #roleInput formControlName="roleControl" [matAutocomplete]="auto"
                                    [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
                                  </mat-chip-grid>
                                  <mat-autocomplete #auto="matAutocomplete" (optionSelected)="addRole($event,gsaColIndex)">
                                    <mat-option *ngFor="let _item of filteredRole | async" [value]="_item.roleName">
                                      {{_item.roleName}}
                                    </mat-option>
                                  </mat-autocomplete>
                                </mat-form-field>
                              </div>
                              <button class="__delete_btn" *ngIf="col.id == '$$edit'" mat-icon-button color="primary"
                                (keyup.Tab)="newGsa($event,gsaColIndex)">
                                <mat-icon class="__delete_icon">delete</mat-icon>
                              </button>
                            </div>
                          </td>

                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="gsaColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: gsaColumns;"></tr>
                      </table>
                    </mat-card-content>
                  </mat-card> -->
                  <mat-card>
                    <mat-card-content formGroupName="address">

                      <h4 class="__card_head">Address Details</h4>
                      <mat-form-field appearance="fill">
                        <mat-label>Client Country</mat-label>
                        <mat-select formControlName="countryId" placeholder="Client Country" required >
                          <mat-option>
                            <!-- formControlName="clientCountryFilteringCtrl" -->
                            <ngx-mat-select-search  [searching]="searching" [formControl]="countrySearchCtrl"
                              noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Client Country">
                              <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                            </ngx-mat-select-search>
                          </mat-option>
                          @for (item of filteredCountries |async; track item) {
                            <mat-option [value]="item.id">
                              {{item.name}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>Client Location in state/Province</mat-label>
                        <mat-select formControlName="stateId" placeholder="Client Location in state/Provinc" required
                          >
                          <mat-option>
                            <!-- formControlName="clientCountryFilteringCtrl" -->
                            <ngx-mat-select-search  [searching]="searching"
                              noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Client Location in state/Provinc">
                              <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                            </ngx-mat-select-search>
                          </mat-option>
                          @for (item of states; track item) {
                            <mat-option [value]="item.id">
                              {{item.name}}
                            </mat-option>
                          }
                        </mat-select>
                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>Client City</mat-label>
                        <mat-select formControlName="cityId" placeholder="Client City" required>
                          <mat-option>
                            <!-- formControlName="clientCountryFilteringCtrl"  -->
                            <ngx-mat-select-search [searching]="searching"
                              noEntriesFoundLabel="'no matching found'" placeholderLabel="Find Client City">
                              <mat-icon ngxMatSelectSearchClear>delete</mat-icon>
                            </ngx-mat-select-search>
                          </mat-option>
                          @for (city of cities; track city) {
                            <mat-option [value]="city.id">
                              {{city.name}}
                            </mat-option>
                          }
                        </mat-select>


                      </mat-form-field>
                      <mat-form-field appearance="fill">
                        <mat-label>ZIP/PIN Code</mat-label>
                        <input matInput placeholder="ZIP/PIN Code" required formControlName="pincode" autocomplete="off">
                      </mat-form-field>
                      <div class="text_area">
                        <mat-form-field appearance="fill">
                          <mat-label>Headquater/Corporate Office Address</mat-label>
                          <textarea matInput resize="0" rows="5" placeholder="Headquater/Corporate Office Address"
                          formControlName="address" autocomplete="off"></textarea>
                        </mat-form-field>
                      </div>
                    </mat-card-content>
                  </mat-card>


                  <mat-card>
                    <mat-card-content>
                      <h4 class="__card_head">Tax Details</h4>
                      <mat-form-field appearance="fill">
                        <mat-label>Client PAN No./Income Tax id</mat-label>
                        <input matInput placeholder="Client PAN No./Income Tax id" required autocomplete="off"
                          formControlName="panNo">
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                          <mat-label>VAT/GST Type</mat-label>
                          <input matInput placeholder="VAT/GST Type" required autocomplete="off">
                        </mat-form-field>
                        <mat-form-field appearance="fill">
                          <mat-label>Client VAT ID/GST ID/Sales Tax ID</mat-label>
                          <input matInput placeholder="Client VAT ID/GST ID/Sales Tax ID" required formControlName="salesTaxId"
                            autocomplete="off">
                          </mat-form-field>
                          <h6 class="__card_sub_head">Register Document Details</h6>
                          <table class="document_list" mat-table [dataSource]="documentDataSource" >
                            @for (col of documentCol; track col; let index = $index) {
                              <ng-container matColumnDef="{{col.id}}">
                                <th mat-header-cell *matHeaderCellDef>
                                  @if (col.id !== '$$edit') {
                                    <span>
                                      {{col.name}}
                                    </span>
                                  }
                                </th>
                                <td mat-cell *matCellDef="let element;let documentColIndex = index;let last = last">
                                  @if (((!element.isEdit || documentIndex!=documentColIndex+1) && last===false)) {
                                    <div
                                      (dblclick)="element.isEdit=!editDocument(documentColIndex+1)">
                                      @if (col.id === '$$edit') {
                                        <div class="btn-edit">
                                          <button class="__delete_btn" (click)="removeDocument(documentColIndex)" mat-icon-button
                                            color="primary">
                                            <mat-icon class="__delete_icon">delete</mat-icon>
                                          </button>
                                        </div>
                                      }
                                      @if (col.id !== 'uploadDocument') {
                                        <span #spanHeader>
                                          {{element[col.id]}}
                                        </span>
                                      }
                                      @if (col.id === 'uploadDocument') {
                                        <span class="__upload_csv">
                                          <mat-icon class="__upload_icon">note_add</mat-icon>
                                        </span>
                                      }
                                    </div>
                                  }
                                  @if (element.isEdit && documentIndex===documentColIndex+1) {
                                    <div
                                      (clickOutside)="updateDocument(documentColIndex)" [excludeBeforeClick]=true [exclude]="'.__editable'"
                                      class="__editable">
                                      @if (col.id === '$$edit') {
                                        <div class="btn-edit">
                                          <button class="__delete_btn" (click)="removeDocument(documentColIndex)" mat-icon-button
                                            color="primary" focusable="false">
                                            <mat-icon class="__delete_icon">delete</mat-icon>
                                          </button>
                                        </div>
                                      } @else {
                                        @if (col.id !== 'uploadDocument') {
                                          <mat-form-field>
                                            <input type="text" [formControl]="getControlDocument(documentColIndex, col.id)" matInput
                                              value="{{element[col]}}">
                                              @if (getControlDocument(documentColIndex, col.id).hasError('required')) {
                                                <mat-error>
                                                  Field is <strong>required</strong>
                                                </mat-error>
                                              }
                                            </mat-form-field>
                                          }
                                          @if (col.id === 'uploadDocument') {
                                            <div class="__upload_csv">
                                              <mat-icon class="__upload_icon">note_add</mat-icon>
                                            </div>
                                          }
                                        }
                                      </div>
                                    }
                                    @if (last===true) {
                                      <div>
                                        @if (col.id !== 'uploadDocument' && col.id !== '$$edit') {
                                          <mat-form-field>
                                            <input type="text" [formControl]="getControlDocument(documentColIndex, col.id)" matInput>
                                          </mat-form-field>
                                        }
                                        @if (col.id === 'uploadDocument') {
                                          <span class="__upload_csv">
                                            <mat-icon class="__upload_icon">note_add</mat-icon>
                                          </span>
                                        }
                                        @if (col.id == '$$edit') {
                                          <button class="__delete_btn" mat-icon-button color="primary"
                                            (keyup.Tab)="newDocument($event,documentColIndex)">
                                            <mat-icon class="__delete_icon">delete</mat-icon>
                                          </button>
                                        }
                                      </div>
                                    }
                                  </td>
                                </ng-container>
                              }
                              <tr mat-header-row *matHeaderRowDef="documentColumns"></tr>
                              <tr mat-row *matRowDef="let row; columns: documentColumns;"></tr>
                            </table>

                            <mat-card-actions>
                              <button mat-button color="secondary" (click)="onSave()">SAVE AS DRAFT</button>
                              <button mat-button color="cancel" (click)="onCancel()">CANCEL</button>
                              <button mat-button color="primary" (click)="onSave()">SAVE</button>
                            </mat-card-actions>
                          </mat-card-content>
                        </mat-card>
                      </form>

                    </div>